import {Button} from "@common/ui/buttons/button";
import {useDownloadWishesPdf} from "@common/auth/ui/account-settings/wish-list-panel/download-wishes-pdf";
import {FileDownloadIcon} from "@common/icons/material/all-icons";
import {openDialog} from "@common/ui/overlays/store/dialog-store";
import {EnterPinDialog} from "@common/workspace/enter-pin-dialog";
import {useUser} from "@common/auth/ui/use-user";


export function DownloadPdfButton({disabled}: { disabled: boolean }) {
  const downloadPdf = useDownloadWishesPdf();

  const {data, isLoading} = useUser('me');
  if (!data?.user || isLoading) {
    return null;
  }

  const onClick = () => {
    if (data.user.has_pin) {
      openDialog(EnterPinDialog, {
        workspaceId: 0,
        setSession: false,
        onVerified: (pin: string) => downloadPdf.mutate({userId: data.user.id, pin}),
      });
    } else {
      downloadPdf.mutate({userId: data.user.id});
    }
  }

  return (
    <div className="text-right m-5">
      <Button type="button" variant="flat" color="primary"
              className="rounded-full shadow-lg"
              disabled={disabled || downloadPdf.isPending}
              onClick={onClick}>
        <FileDownloadIcon/>
      </Button>
    </div>
  )
}
